import {midiDispatcher} from "../modules/midi/MidiDispatcher";

type ShortcutConfigurationCode = 'midi' | 'Space' | 'Enter'

export class ShortcutConfiguration {

  constructor(code: ShortcutConfigurationCode, callback: () => void, priority: number, group: string) {
    this.code = code;
    this.callback = callback;
    this.priority = priority;
    this.group = group;
  }

  code: ShortcutConfigurationCode;
  callback: () => void;
  priority: number;
  group: string;
}

const MIN_PRIORITY = -1000;

// TODO: Possible improvement depending on future use case
// * Use boolean functions for shortcut callback if shortcut return false then call the shortcut with a lower priority
class ShortcutsStore {

  private registeredShortcuts: Map<ShortcutConfigurationCode, ShortcutConfiguration[]> = new Map()

  constructor() {
    const shortcutStore = this;
    window.addEventListener('keydown', (e: KeyboardEvent) => ShortcutsStore.onKeyPressed(shortcutStore, e));

    midiDispatcher.on('activeKeysChanged', () => {
      shortcutStore.registeredShortcuts.forEach((shortcuts, code) => {
        if (code === "midi") {
          // TODO: should be changed if there are multiple shortcuts
          if (shortcuts[0]) {
            shortcuts[0].callback()
          }
        }
      })
    })
  }

  // TODO: Could add duplication validation & priority check
  public registerShortcut(shortcutConfiguration: ShortcutConfiguration) {
    const shortcutConfigurationsForKey = this.registeredShortcuts.get(shortcutConfiguration.code) ?? []
    shortcutConfigurationsForKey.push(shortcutConfiguration);

    this.registeredShortcuts.set(shortcutConfiguration.code, shortcutConfigurationsForKey);
  }

  // TODO: Could check if resulting arrays are empty to prevent test on shortcuts.length in onKeyPressed.
  public unregisterShortcutsForGroup(group: string) {
    this.registeredShortcuts.forEach((shortcutConfigurations, code) => {
      this.registeredShortcuts.set(code, shortcutConfigurations.filter((shortcutConfiguration) => {
        return shortcutConfiguration.group !== group;
      }));
    })
  }

  private static onKeyPressed(shortcutStore: ShortcutsStore, e: KeyboardEvent) {
    shortcutStore.registeredShortcuts.forEach((shortcuts, code) => {
      if (e.code === code && shortcuts.length > 0) {
        e.preventDefault();

        let maxPriority = MIN_PRIORITY;
        let shortcutCallback = () => console.log('issue with shortcuts for key : ' + e.code);

        shortcuts.forEach((shortcut) => {
          if (shortcut.priority >= maxPriority) {
            maxPriority = shortcut.priority;
            shortcutCallback = shortcut.callback;
          }
        })

        shortcutCallback();
      }
    })
  }
}

export const shortcutsStore = new ShortcutsStore();
